export default __webpack_public_path__ + "static/media/DegreeLevelExl.792d688c.xlsx";